import { useState } from "react";
import Title from "../common/Title";
import { POPULAR_DESTINATIONS_LIST, TABS_LIST } from "../common/Helper";
import { LocationSecondIcon, ReadMoreIcon, StarIcon } from "../common/Icons";
import PrimaryBtn from "../common/PrimaryBtn";

const PopularDestinations = () => {
  const [activeTab, setActiveTab] = useState(TABS_LIST[0].title);
  const [visibleCards, setVisibleCards] = useState(3);

  const handleSeeAll = () => {
    setVisibleCards((prevCount) =>
      Math.min(prevCount + 3, POPULAR_DESTINATIONS_LIST.length)
    );
  };

  return (
    <div className="container 2xl:max-w-[1240px] px-5 mx-auto pb-[120px] lg:pt-2 max-lg:pb-20">
      <div>
        <Title text={"Popular Destinations"} myClass={"text-center"} />
      </div>

      <div className="flex justify-center pt-5 pb-[50px] max-md:pb-10 px-4">
        <div className="max-md:overflow-x-scroll pb-2 whitespace-nowrap scrollbar-thin scrollbar-thumb-[#FF5858] scrollbar-track-[#FF5858] scrollbar-thumb-rounded max-w-full flex gap-6 custom-scrollbar">
          {TABS_LIST.map((tab) => (
            <button
              key={tab.title}
              onClick={() => setActiveTab(tab.title)}
              className={`text-[#010101] ff-sans text-xl leading-[100%] px-4 ${
                activeTab === tab.title ? "text-[#FF5858]" : ""
              }`}
            >
              {tab.title}
            </button>
          ))}
        </div>
      </div>

      <div className="flex flex-wrap items-center justify-center gap-6">
        {POPULAR_DESTINATIONS_LIST.slice(0, visibleCards).map((item, index) => (
          <div
            key={index}
            className="p-4 w-full xl:max-w-[382px] lg:max-w-[300px] sm:max-w-[47%] border border-black/20 rounded-[12px] hover:border-black/10 hover:shadow-[0px_7px_22.1px_0px_#0000001F] transition-shadow duration-300"
          >
            <img
              src={item.image}
              alt={item.place}
              className="rounded-[12px] w-full h-[266px] object-cover pointer-events-none"
            />
            <div className="px-[19px] max-lg:px-4">
              <div className="pt-5 max-md:pt-3 flex items-center justify-between">
                <div className="flex items-center gap-2 ">
                  <LocationSecondIcon />
                  <p className="text-[#019FDB] text-sm leading-[100%] font-medium">
                    {item.location}
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <StarIcon />
                  <p className="text-[#363636] font-medium text-lg leading-[100%]">
                    {item.rating}
                  </p>
                </div>
              </div>
              <p className="font-medium text-xl leading-[100%] text-[#010101] pt-[18px] max-lg:pt-3 max-md:text-xl">
                {item.place}
              </p>
              <p className="text-[#363636] ff-sans leading-[150%] text-sm pt-[6px] max-md:pt-0.5">
                {item.days}
              </p>
              <div className="flex items-center justify-between pt-[30px] max-lg:pt-5 pb-[18px] max-lg:pb-3">
                <p className="text-[#019FDB] font-medium text-[26px] max-md:text-2xl leading-[100%]">
                  {item.price}$
                </p>
                <p className="flex items-center gap-1 text-[#363636] ff-sans leading-[120%] font-semibold text-sm">
                  Read More <ReadMoreIcon />
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {visibleCards < POPULAR_DESTINATIONS_LIST.length && (
        <div className="text-center mt-[50px] max-md:mt-10">
          <PrimaryBtn
            text="See All"
            onClick={handleSeeAll}
            myClass="!px-[38px] !py-[13px]"
          />
        </div>
      )}
    </div>
  );
};

export default PopularDestinations;
